/* eslint-disable */
import React from 'react';
import * as _ from 'lodash';
import { getTeamUrl } from '../utils/routes';
import { getArenaBg } from '../utils/matches';
import { getProxyUrl } from '../utils/image';
import { useTeamLogo } from '../hooks/team';
import countriesDictionaryEn from '../dictionaries/countries/en/countries.json';
import countriesDictionarySv from '../dictionaries/countries/sv/countries.json';
import positionsDictionaryEn from '../dictionaries/positions/en/positions.json';
import positionsDictionarySv from '../dictionaries/positions/sv/positions.json';

function Translate(phrase, en, sv) {
  let translation;
  let translationId;
  en.map((dictionaryEn) => {
    if (dictionaryEn.name === phrase) {
      translationId = dictionaryEn.id;
    }
  });
  sv.map((dictionarySv) => {
    if (dictionarySv.id === translationId ) {
      translation = dictionarySv.name;
    }
  });
  return translation ? translation : phrase;
}

function PlayerHero({ playerInformation, teamLogos }) {
  const bg = getArenaBg(playerInformation?.teamAbbrv);
  const bgUrl = getProxyUrl(bg, 800, 800);
  const [teamLogo] = useTeamLogo(playerInformation?.teamAbbrv);

  const countrySv = Translate(playerInformation?.nationality, countriesDictionaryEn, countriesDictionarySv);
  const positionSv = Translate(playerInformation?.position, positionsDictionaryEn, positionsDictionarySv);

  return (
    <>
      <div className="hero-image">
        <a className="hero-image__back" href="/">
          <img
            src="/wp-content/themes/sef-leagues/images/arrow-back.svg"
            alt="Back"
          />
        </a>
        <div
          className="hero-image__container d-flex align-items-center"
          style={{
            backgroundImage: 'url('+bgUrl+')'
          }}
        >
          <div className="player-hero player-hero__general d-flex align-items-center flex-grow-1">
            <img
              className="player-hero__bust-image"
              src={playerInformation?.playerImage}
              alt=""
            />
            <div className="ms-2 ms-lg-5">
              <p className="heading-h5 heading-lg-h4 text-color-primary-yellow">
                {playerInformation?.shirtNumber}
              </p>
              <h1 className="heading-h4 heading-lg-h2">
                {playerInformation?.name}
              </h1>
              <a
                href={getTeamUrl(playerInformation?.teamAbbrv)}
                className="name-with-team-logo name-with-team-logo--large"
              >
                {teamLogo && ( 
                  <img
                    src={getProxyUrl(teamLogo, 50, 50)}
                    alt=""
                  />
                )}
                <span className="heading-h6 heading-lg-h5 text-color-primary-yellow text-transform-none">
                  {playerInformation?.currentTeam}
                </span>
              </a>
            </div>
          </div>
          <div className="player-hero__info">
            <div className="data-container">
              <div className="data-container__row d-flex align-items-center px-3 py-1">
                <div className="text-regular fw-bold flex-grow-1">Född</div>
                <div className="text-regular">
                  {playerInformation?.birthDate}
                </div>
              </div>
              <div className="data-container__row d-flex align-items-center px-3 py-1">
                <div className="text-regular fw-bold flex-grow-1">Ålder</div>
                <div className="text-regular">{playerInformation?.age}</div>
              </div>
              <div className="data-container__row d-flex align-items-center px-3 py-1">
                <div className="text-regular fw-bold flex-grow-1">
                  Nationalitet
                </div>
                <div className="text-regular">
                  { countrySv }
                </div>
              </div>
              <div className="data-container__row d-flex align-items-center px-3 py-1">
                <div className="text-regular fw-bold flex-grow-1">Position</div>
                <div className="text-regular">
                  { positionSv }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PlayerHero;
